import Vue from "vue";
import VueRouter from "vue-router";
import ServiceLog from "@/views/ServiceLog.vue";
import CreateEntry from "@/views/CreateEntry.vue";
import RequestService from "@/views/RequestService.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: ServiceLog,
  },
  {
    path: "/new",
    name: "new",
    component: CreateEntry,
  },
  {
    path: "/request-service",
    name: "requestService",
    component: RequestService,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
